import type { Delta } from 'quill/core';

import type { BaseRteHeadingType } from '#/components/BaseRte/types/BaseRteHeadingType';
import { baseRteHeaderNumberByHeadingType } from '#/components/BaseRte/types/BaseRteHeadingType';

type Args = {
  types: BaseRteHeadingType[];
};

export function baseRteCreateStripHeadersExcept({ types }: Args) {
  const allowedHeaderNumbers = types.map(
    (type) => baseRteHeaderNumberByHeadingType[type],
  );

  return function stripHeadersExepct(_node: HTMLElement, delta: Delta) {
    delta.ops.forEach((op) => {
      if (!op.attributes?.header) return;

      if (!allowedHeaderNumbers.includes(op.attributes.header as number)) {
        // eslint-disable-next-line no-param-reassign
        op.attributes.header = undefined;
      }
    });

    return delta;
  };
}
